<template>
  <div class="mt-2 mb-2">
    <v-btn
      :disabled="!isFormValid"
      type="submit"
      class="button"
      :loading="isLoading"
      x-large
      block
      outlined
      data-test-login
    >
      {{ $t(`components.login.${component}.submit`) }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginComponentSubmitButton extends Vue {
  @Prop()
  component!: string;

  @Prop()
  isFormValid!: string;

  @Prop({ default: false })
  isLoading?: boolean;
}
</script>
